"use client";

import { createContext, useContext, type ReactNode } from "react";

import { useReducedMotion } from "@/hooks/use-reduced-motion";

type MotionContextType = {
  prefersReducedMotion: boolean;
  setMotionPreference: (reduced: boolean) => void;
  isSystemPreference: boolean;
  resetToSystemPreference: () => void;
};

const MotionContext = createContext<MotionContextType | undefined>(undefined);

export function MotionProvider({ children }: { children: ReactNode }) {
  const motionPreferences = useReducedMotion();

  return (
    <MotionContext.Provider value={motionPreferences}>
      {children}
    </MotionContext.Provider>
  );
}

export function useMotion(): MotionContextType {
  const context = useContext(MotionContext);
  if (context === undefined) {
    throw new Error("useMotion must be used within a MotionProvider");
  }
  return context;
}
